// This is the full set of variables the *application* code (not the server, or the Webpack process)
// needs in order to be bundled and run in the browser.
module.exports = [
  "OAUTH_CLIENT_ID",
  "ENVIRONMENT",
  "GIT_COMMIT",
  "BACKEND_ROOT",
  "FRONTEND_ROOT",
  "GRAPHQL_ROOT",
  "ENABLE_SENTRY_REPORTING",
  "ENABLE_REDUX_DEVTOOLS",
  "ENABLE_APOLLO_DEVTOOLS",
  "GTM_ENV",
];
